




























import { VueConstructor } from 'vue';
import { computed, defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
	props: {
		hasError: Boolean,
		// eslint-disable-next-line vue/require-prop-types
		value: {
			type: [String, Date],
			default: '',
		},
		id: {
			type: String,
			default: '',
		},
		tag: {
			type: String as PropType<null | string | VueConstructor>,
			default: undefined,
		},
		step: {
			type: Number,
			default: null,
		},
		min: {
			type: String,
			default: '',
		},
		max: {
			type: String,
			default: '',
		},
		displayTimeZone: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, ctx) {
		// InputFacade breaks on Safari for some reason, so use a normal input here
		const is = computed(() => (props.tag ? props.tag : 'input'));
		const formatter = new Intl.DateTimeFormat(ctx.root.$i18n.locale, { timeZoneName: 'short' });
		// We use a computed value based on the selected date to account for changes
		// between daylight savings and non-daylight savings to show the correct TZ
		// for the select date
		const timeZoneName = computed(() => formatter
			.formatToParts(props.value ? new Date(props.value) : new Date())
			.find(({ type }) => type === 'timeZoneName')
			?.value);
		const handleInput = (e: InputEvent) => {
			ctx.emit('input', (e?.target as HTMLInputElement | undefined)?.value);
		};
		return {
			is,
			timeZoneName,
			handleInput,
		};
	},
});
